module.exports = __webpack_public_path__ + "static/media/psd-2.b0d37f8b.svg";